const storage = window.localStorage;
const session = window.sessionStorage;
export const setItem = (prop, val) => {
  if (!storage) {
    return false;
  }
  return storage.setItem(prop, val);
};
export const getItem = prop => {
  if (!storage) {
    return undefined;
  }
  return storage.getItem(prop);
};
export const storageClear = () => {
  if (storage) {
    storage.clear();
  }
};
export const removeItem = prop => {
  if (storage) {
    storage.removeItem(prop);
  }
};

export const sessionSetItem = (prop, val) => {
  if (!session) {
    return false;
  }
  return session.setItem(prop, JSON.stringify(val));
};

export const sessionSetItemValue = (prop, val) => {
  if (session) {
    session.setItem(prop, val);
  }
};

export const sessionGetItemValue = prop => {
  if (!session) {
    return null;
  }
  return session.getItem(prop) || null;
};

export const sessionGetItem = prop => {
  if (!session) {
    return null;
  }
  const value = window.sessionStorage.getItem(prop);
  return value ? JSON.parse(value) : null;
};

export const storageSessionClear = () => {
  if (session) {
    window.sessionStorage.clear();
  }
};

export const sessionRemoveItem = prop => {
  if (session) {
    session.removeItem(prop);
  }
};

export const removeSessionItems = items => {
  items.forEach(item => sessionStorage.removeItem(item));
};

export function updateSessionStorage(sessionKey, key, value) {
  const sessionData = sessionStorage.getItem(sessionKey);
  let data = {};
  if (sessionData) {
    data = JSON.parse(sessionData);
  }

  data[key] = value;

  sessionStorage.setItem(sessionKey, JSON.stringify(data));
}
